import {
  api_group_admin_path,
  api_group_admins_path,
  welcome_email_api_group_admins_path,
} from '@routes';

import request from './request';

export interface GroupAdminParams {
  admin: {
    name: string;
    email: string;
  };
}

export interface UpdateGroupAdminParams {
  admin: {
    name: string;
    email: string;
  };
  id: number;
}

export interface GroupAdminResponse {
  message: string;
}

export interface GroupAdminEmailParams {
  organization_id: number;
  user_ids: number;
}

/**
 * Creates a group admin.
 */
export async function createGroupAdmin(params: GroupAdminParams): Promise<GroupAdminResponse> {
  const response = await request('post', api_group_admins_path(), params);
  return response;
}

/**
 * Updates a group admin's information.
 */
export async function updateGroupAdmin(
  params: UpdateGroupAdminParams
): Promise<GroupAdminResponse> {
  const { id } = params;
  const response = await request('patch', api_group_admin_path({ id }), params);
  return response;
}

/**
 * Deactivates a group admin.
 */
export async function removeGroupAdmin(id: number): Promise<GroupAdminResponse> {
  const response = await request('delete', api_group_admin_path({ id }));
  return response;
}

/**
 * Sends a welcome email to group admin.
 */
export async function sendGroupAdminWelcomeEmail(
  params: GroupAdminEmailParams
): Promise<GroupAdminResponse> {
  const response = await request('post', welcome_email_api_group_admins_path(), params);
  return response;
}
